/* eslint max-classes-per-file: 0 */

import {
  RoadmapDirection as Data,
  RoadmapDirectionCollection as Collection,
} from '@/typings/api/RoadmapDirection'
import { RoadmapDirectionsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class RoadmapDirectionsTransformerParams extends TransformerParams {
  protected defaultParams = ['roadmap_id'];
}

export class RoadmapDirectionsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new RoadmapDirectionsTransformerParams();
}
